export enum RolesEnum {
    SystemAdministrator = 'System Administrator',
    Cashier = 'Cashier',
    AssetsManage = 'Assets Manager',
    InvoicingManager = 'Invoicing Manager',
    ProductionManager = 'Production Manager',
    OrderManager = 'Order Manager',
    OrderTaker = 'Order Taker',
    PurchaseRequester = "Purchase Requester",
    PurchasingManager = "Purchasing Manager",
    PWAUser = 'PWA User',
    Subscriber = 'Subscriber',
    EdaraSupport = 'Edara Support',
}
